import { Entity } from '@backstage/catalog-model';
import {
  EntityFilter,
  DefaultEntityFilters,
  useEntityList,
  CatalogAutocomplete,
} from '@backstage/plugin-catalog-react';
import { Box, Checkbox, FormControlLabel, TextField } from '@material-ui/core';
import { useEffect, useState } from 'react';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';

export class SystemEntityTierFilter implements EntityFilter {
  constructor(readonly values: number[]) {}
  filterEntity(entity: Entity): boolean {
    const tier = (entity.spec?.criticality as { tier: number })?.tier;
    return tier !== undefined && this.values.includes(tier);
  }
}

type CustomFilters = DefaultEntityFilters & {
  tiers?: SystemEntityTierFilter;
};

export const EntityTierPicker = () => {
  const {
    filters: { kind },
    updateFilters,
  } = useEntityList<CustomFilters>();

  const [selectedTiers, setSelectedTiers] = useState<[number, string][]>([]);

  useEffect(() => {
    const newTiers = selectedTiers.map(([tier]) => tier);
    updateFilters({
      tiers: newTiers.length ? new SystemEntityTierFilter(newTiers) : undefined,
    });
  }, [selectedTiers, updateFilters]);

  const selectedKind = kind?.value;
  if (selectedKind && selectedKind !== 'system' && selectedKind !== 'component') return null;

  const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
  const checkedIcon = <CheckBoxIcon fontSize="small" />;

  // Tiers from:
  // https://moveinc.atlassian.net/wiki/spaces/ENGN/pages/117268938883/System+Tiering#Tier-Definitions
  const tierOptions: [number, string][] = [
    [1, 'Critical'],
    [2, 'High'],
    [3, 'Medium'],
    [4, 'Low'],
  ];

  return (
    <Box pb={1} pt={1}>
      <CatalogAutocomplete<[number, string], true>
        name="tier-filter"
        label="Tier"
        multiple
        disableCloseOnSelect
        options={tierOptions}
        value={selectedTiers}
        getOptionSelected={([op], [val]) => op === val}
        getOptionLabel={([tier]) => `Tier ${tier}`}
        onChange={(_, value) => {
          setSelectedTiers(value as any);
        }}
        renderInput={params => <TextField {...params} variant="outlined" />}
        renderOption={([tier, criticality], { selected }) => {
          return (
            <FormControlLabel
              control={<Checkbox icon={icon} checkedIcon={checkedIcon} checked={selected} />}
              label={`Tier ${tier} (${criticality})`}
              onClick={event => event.preventDefault()}
            />
          );
        }}
      />
    </Box>
  );
};
